export const DEFAULT_FAVORITE_FOLDER = 'My Favorite';
export const DEFAULT_FAVORITE_FOLDER_ID = 'my-favourites';
export const MAX_NUMBER_OF_FAVORITE_FOLDER = 10;
export const MAX_NUMBER_OF_ALLOWABLE_FAVORITES_IN_A_FOLDER = 20;

export const FAVORITE_PAGE_TYPES = Object.freeze({
  SITE: 'SITE',
  ASSET: 'ASSET',
  TRENDS: 'TRENDS',
  SITE_LIST: 'SITE_LIST',
});

// Lookup keys are URL fragments scanned via
//   Object.keys(favoritePageIds).find(o => pathname.includes(o)).
// 'opportunity' MUST stay declared above 'trends-view' so
// /<bundle>/trends-view/opportunity/... matches the opportunity entry first.
//
// `value`    - wire `favoritePageId` stored by the service.
// `pageType` - wiki bucket; picks the metadata shape and the identity-field
//              set used by the saga + selectors.
export const favoritePageIds = {
  'site-details/pai/active': {
    value: 'TODO_LIST',
    key: 'sites',
    pageType: FAVORITE_PAGE_TYPES.SITE,
    displayName: 'To_do_list',
  },
  'site-details/ais/active': {
    value: 'SITE_SUMMARY',
    key: 'sites',
    pageType: FAVORITE_PAGE_TYPES.SITE,
    displayName: 'Site_Summary',
  },
  'equipment-details/pai/details': {
    value: 'EQUIPMENT',
    key: 'assets',
    pageType: FAVORITE_PAGE_TYPES.ASSET,
    displayName: 'Equipment',
  },
  opportunity: {
    value: 'PORTFOLIO_TREND_REPORT',
    key: 'trends',
    pageType: FAVORITE_PAGE_TYPES.TRENDS,
    displayName: 'Portfolio Trend Report',
  },
  'trends-view': {
    value: 'PORTFOLIO_TREND',
    key: 'trends',
    pageType: FAVORITE_PAGE_TYPES.TRENDS,
    displayName: 'Portfolio Trend Home',
  },
  'temperature-and-consumption': {
    value: 'Temperature_and_consumption_view',
    key: 'sites',
    pageType: FAVORITE_PAGE_TYPES.SITE,
    displayName: 'Temperature_and_consumption_view',
  },
  'live-connect': {
    value: 'LIVE_CONNECT',
    key: 'sites',
    pageType: FAVORITE_PAGE_TYPES.SITE,
    displayName: 'Live_Connect',
  },
  'site-list': {
    value: 'SITE_LIST_CATEGORY',
    key: 'siteList',
    pageType: FAVORITE_PAGE_TYPES.SITE_LIST,
    displayName: 'Site_List',
  },
};

// State-aware override used by TrendsView/components/Header.js when
// `filterObj.comboCode` is set: forces the opportunity-report variant even
// when the URL is just `/<bundle>/trends-view`.
export const favoriteCombiCodePageIds = {
  value: 'PORTFOLIO_TREND_REPORT',
  key: 'trends',
  pageType: FAVORITE_PAGE_TYPES.TRENDS,
  displayName: 'Portfolio Trend Report',
};

export const favoritePageNames = {
  favSiteSummary: 'SITE_SUMMARY',
  favTodoList: 'TODO_LIST',
  favEquipment: 'EQUIPMENT',
  favPortFolioTrend: 'PORTFOLIO_TREND',
  favPortFolioTrendReport: 'PORTFOLIO_TREND_REPORT',
  favTC: 'Temperature_and_consumption_view',
  favLiveConnect: 'LIVE_CONNECT',
};

export const favoriteTypeLabel = {
  ASSET: 'assets',
  SITE: 'sites',
  TREND: 'trends',
  SITE_SUMMARY: 'SITE_SUMMARY',
  TODO_LIST: 'TODO_LIST',
  EQUIPMENT: 'EQUIPMENT',
  PORTFOLIO_TREND: 'PORTFOLIO_TREND',
  PORTFOLIO_TREND_REPORT: 'PORTFOLIO_TREND_REPORT',
  Temperature_and_consumption_view: 'Temperature_and_consumption_view',
  live_connect: 'LIVE_CONNECT',
  SITELIST: 'siteList',
  SITE_LIST_CATEGORY: 'SITE_LIST_CATEGORY',
};

export const DEFAULT_FAVORITE_FOLDER_1 = {
  label: 'My_Favorite',
  value: 'My Favorite',
};
